import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_rmb",
  "use": "icon-project_rmb-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_rmb\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><path d=\"M14 27c7.18 0 13-5.82 13-13S21.18 1 14 1C9.441 1 5.29 3.365 2.936 7.171A12.933 12.933 0 001 14c0 7.18 5.82 13 13 13z\" /><path stroke-linecap=\"round\" d=\"M9.357 7.957l4.62 4.62M18.643 7.957l-4.62 4.62M10 17h8M10 13h8M14 13v9\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol